module.exports = __webpack_public_path__ + "static/img/effortlessPhone.ee528669.png";